import * as React from 'react';
import { IGroupedComboBoxButtonLabelProps } from 'grouped-combobox-web';
import { FontIcon } from '@fluentui/react';
import { isMruEntry } from 'modern-font-picker-core';

export default function renderLabelWithPreviewFont(
    props: IGroupedComboBoxButtonLabelProps,
    previewFontFamily: string | undefined
): React.ReactNode {
    const { item, labelClassName, indicatorClassName, indicatorIconName } = props;
    const { text, displayText, showIndicator, data } = item;
    const label = displayText ?? text;
    const fontFamily =
        data && isMruEntry(data) && data.previewFontName
            ? data.previewFontName
            : displayText
            ? previewFontFamily
            : undefined;

    return (
        <>
            {showIndicator && (
                <FontIcon
                    className={indicatorClassName}
                    iconName={indicatorIconName ?? 'NewFont-svg'}
                />
            )}
            <span
                className={labelClassName}
                style={
                    fontFamily !== undefined
                        ? {
                              fontFamily,
                          }
                        : undefined
                }
            >
                {label}
            </span>
        </>
    );
}
